<!-- display-mobile-13 preview — a 300x250 medium rectangle in the middle of a
     publisher page. The creative is not shown straight: it is blurred out to
     fill the whole slot, and a white card carrying the copy sits on top of it. -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad">
      <!-- Decorative on purpose: the card covers most of it and every part of
           the ad the reader can act on is a link of its own below. -->
      <!-- Not dimension-routed, unlike the other placements: this wash is the only
           thing the creative is used for here, and a blurred ground has no format —
           any of the four upload sizes reads the same once it is blurred. -->
      <img class="da-backdrop" [src]="data.image" alt="" aria-hidden="true" />

      <span class="da-adchoices d-flex align-items-center justify-content-center">
        <i class="bi bi-info-circle"></i>
      </span>

      <div class="da-card d-flex flex-column align-items-center">
        <!-- GenSingleImagePreviewData carries no advertiser field, so the mark is
             a literal here, the same compromise the other placements make. -->
        <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
        <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>

        <div class="da-desc">
          {{ data.descriptions[0] || "Your description appears here" }}
        </div>

        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta">
          {{ data.ctaText || "Your call to action" }}
        </a>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad; the last row clips at the frame -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
